module.exports = __webpack_public_path__ + "img/sustainable_energy_details.21b385ec.svg";